"use client";

import React, { FC, useMemo } from "react";
import classNames from "classnames";

import { Icon } from "components/atoms/Icon/Icon";
import { IButton, IconType } from "@types";

import s from "./Button.module.scss";

export const HubspotButton: FC<IButton> = ({
  text,
  label,
  theme = "dark",
  icon,
  iconSize,
  preIcon = false,
  mirrorIcon = false,
  disabled = false,
  hubspotCodeSnippet,
}) => {
  const iconColor = theme === "dark" ? "white" : "blue";
  const correctedIconSize = iconSize || (icon === IconType.CaretFilled ? "s" : "m");

  const content = useMemo(
    () => (
      <>
        {preIcon && icon && (
          <span className={s.ButtonPreIcon}>
            <Icon name={icon} size={correctedIconSize} color={iconColor} mirror={mirrorIcon} />
          </span>
        )}
        <span className={s.ButtonText}>{text ?? label}</span>
        {!preIcon && icon && (
          <span className={s.ButtonIcon}>
            <Icon name={icon} size={correctedIconSize} color={iconColor} mirror={mirrorIcon} />
          </span>
        )}
      </>
    ),
    [preIcon, icon, correctedIconSize, iconColor, mirrorIcon, text, label],
  );

  return (
    <button
      type="button"
      disabled={disabled}
      className={classNames("button", hubspotCodeSnippet, s.Button, {
        [s.ButtonNone]: theme === "none",
        [s.ButtonLight]: theme === "light",
        [s.ButtonDark]: theme === "dark",
        [s.ButtonTextual]: theme === "textual",
        [s.ButtonTextualWhite]: theme === "textual-white",
      })}
    >
      {content}
    </button>
  );
};
